import sanityClient from '@sanity/client'
import imageUrlBuilder from '@sanity/image-url'

const client = sanityClient({
	projectId: process.env.GATSBY_SANITY_PROJECT_ID,
	dataset: process.env.GATSBY_SANITY_DATASET,
	apiVersion: '2022-07-01',
})

const builder = imageUrlBuilder(client)

export const urlFor = source => builder.image(source)
